import { VariablesOf } from '@graphql-typed-document-node/core';
import { queryOptions } from '@tanstack/react-query';

import { datoRequester } from 'queries/requesters';
import { StaleTime } from 'queries/types';
import { AffiliateByTicketingIdDocument } from 'types/api/dato-operations.types';

const AFFILIATE_PREFIX = 'affiliate';

export const affiliateByTicketingQuery = (
  variables: VariablesOf<typeof AffiliateByTicketingIdDocument>,
) =>
  queryOptions({
    queryKey: [AFFILIATE_PREFIX, 'detail', variables],
    queryFn: datoRequester(AffiliateByTicketingIdDocument, variables),
    staleTime: StaleTime.ONE_HOUR,
  });
